import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initializeApiClient } from "api-client";
import Root from "./providers.tsx";
import "./index.scss";

// Initialize API client with auth interceptors
initializeApiClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>
);
